import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'getContingentStatusCssClassPipe',
    standalone: true
})
export class GetContingentStatusCssClassPipe implements PipeTransform {
  transform(
    value: number
  ): string {
    if(value <= 50) {
      return 'text-success';
    } else if (value > 50 && value <= 80) {
      return 'text-warning';
    } else if (value > 80 && value <= 99) {
      return 'text-orange';
    } else {
      return 'text-danger';
    }
  }
}
